<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useProjectStore } from '@/stores/project'
import { INDEX_ROUTES } from '@/router'

const { currentItem: currentProject } = storeToRefs(useProjectStore())
</script>

<template>
	<v-breadcrumbs-item>
		<router-link
			class="text-white toolbar-text text-decoration-none"
			:to="{ name: INDEX_ROUTES.PROJECT.INDEX.name }"
		>
			Projects
		</router-link>
	</v-breadcrumbs-item>

	<template v-if="currentProject?.id">
		<v-breadcrumbs-divider />
		<v-breadcrumbs-item>
			<router-link
				class="text-white toolbar-text text-decoration-none"
				:to="{ name: INDEX_ROUTES.PROJECT.INDEX.name }"
			>
				{{ currentProject?.name }}
			</router-link>
		</v-breadcrumbs-item>
	</template>
</template>
